export enum LazyModuleTypes {
    CHARTS = 'CHARTS',
    MAPS = 'MAPS'
}
